module.exports = __webpack_public_path__ + "static/media/point.fbe34899.svg";